module.exports = __webpack_public_path__ + "img/大型能源集团产融大数据分析平台建设探索及实践—国家能源集团神华财务有限公司—1-1.854a3fb2.jpg";